export const defaultSorted = [{ dataField: "id", order: "asc" }];
export const sizePerPageList = [
  { text: "20", value: 20 },
  { text: "50", value: 50 },
  { text: "100", value: 100 },
];
export const initialFilter = {
  sortOrder: "desc", // asc||desc
  sortField: "created_at",
  searchKey: "",
  pageNumber: 1,
  pageSize: 20,
};
